import React, { useCallback, useEffect, useState } from 'react'
import { Paper } from '@material-ui/core'
import _orderBy from 'lodash/orderBy'
import _reverse from 'lodash/reverse'
import DataTable from '../../../../app/components/statelessDataTable'
import createColumns from './columns'
import { paperStyles } from './styles'
import { handlePagination } from '../../../../common/helpers'
import { filterLocations } from '../../../../common/utils/addressUtilities'

const LocationsAffectedAddressModal = ({ locations }) => {
  const [data, setData] = useState([])
  const [total, setTotal] = useState(0)
  const [pageNumber, setPageNumber] = useState(1)
  const [searchText, setSearchText] = useState('')
  const [sortOptions, setSortOptions] = useState({})
  const [filters, setFilters] = useState({ state: '' })
  const [filterOptions, setFilterOptions] = useState({
    filter: '',
    field: ''
  })
  const [columns, setColumns] = useState(createColumns({
    sortOptions,
    filterOptions,
    eventHandlers: {
      setSortOptions,
      setFilterOptions,
      setPageNumber
    }
  }))
  const [loading, setLoading] = useState(false)

  const rowsPerPage = 20

  useEffect(() => {
    let subscribed = true
    if (subscribed && locations) {
      setLoading(true)
      const sortedFilteredLocations = sortAndFilterLocations(locations, searchText, sortOptions)
      const paginatedLocations = handlePagination(sortedFilteredLocations, rowsPerPage, pageNumber)
      setData(paginatedLocations)
      setTotal(sortedFilteredLocations.length)
    }
    setColumns(createColumns({
      sortOptions,
      filterOptions,
      eventHandlers: {
        setSortOptions,
        setFilterOptions,
        setPageNumber
      }
    }))
    setLoading(false)
    return () => (subscribed = false)
  }, [pageNumber, filters, searchText, sortOptions, filterOptions])

  const handleChangePage = useCallback((event) => {
    setPageNumber(event.selected + 1)
    setData([])
    setLoading(true)
  }, [])

  const handleSetSearchText = useCallback((value) => {
    setSearchText(value)
  }, [])

  const handleSetSortOptions = useCallback((value) => {
    setSortOptions(value)
  }, [])

  const handleSetFilters = (value) => {
    setFilters(value)
    setPageNumber(1)
  }

  const handleSetPageNumber = useCallback((value) => {
    setPageNumber(value)
  }, [])

  const sortAndFilterLocations = (originalLocations, searchTerm, inputSortOptions) => {
    const unsortedLocations = filterLocations(originalLocations, searchTerm)
    const { field, direction } = inputSortOptions

    const getLower = (value) => ((typeof value === 'string')
      ? value.toLowerCase()
      : value)

    const staticOrder = _orderBy(
      unsortedLocations,
      [(location) => ((field === 'displayName')
        ? location.name.toLowerCase()
        : getLower(location[field]))],
      ['asc']
    )

    return direction === 'desc'
      ? _reverse(staticOrder)
      : staticOrder
  }

  return (
    <Paper style={paperStyles} data-testid="locations-affected-modal">
      <DataTable
        {...{
          pageCount: Math.ceil(total / rowsPerPage),
          isLoading: loading,
          recordType: 'Locations',
          showSearch: true,
          showExport: false,
          showLocaleFilter: false,
          eventHandlers: {
            handleChangePage,
            setSearchText: handleSetSearchText,
            setSortOptions: handleSetSortOptions,
            setFilters: handleSetFilters,
            setPageNumber: handleSetPageNumber
          },
          columns,
          data,
          filters,
          sortOptions,
          filterOptions,
          pageNumber,
          total,
          searchText,
          rowsPerPage
        }}
      />
    </Paper>
  )
}

export default LocationsAffectedAddressModal
